import validate from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/middleware/auth.global.ts";
import permission_45global from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/middleware/permission.global.ts";
import manifest_45route_45rule from "D:/TruongHocAnToan/ConanEdu_CMS/trunk/source/ConanEdu.CMS/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  permission_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}